'use client'
import {formatNumber} from "@/lib/format-number";
import {useEffect, useState} from "react";


function useCountUp(target: number, durationMs = 1500) {
  const [value, setValue] = useState(0);
  useEffect(() => {
    const start = performance.now();
    const tick = (t: number) => {
      const elapsed = t - start;
      const p = Math.min(1, elapsed / durationMs);
      setValue(Math.floor(target * (0.2 + 0.8 * p))); // slight jump at beginning
      if (p < 1) requestAnimationFrame(tick);
    };
    const id = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(id);
  }, [target, durationMs]);
  return value;
}

export function CountUp({target, durationMs = 1500}: { target: number, durationMs?: number }) {
  const value = useCountUp(target, durationMs);
  const formatted = formatNumber(value)

  return <>{formatted}</>;
}
